import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BackOfficeInvoiceConfig } from './BackOfficeInvoiceConfig';

export class BackOfficeContractConfig extends BackOfficeInvoiceConfig {
    _originalTypeClassName = "zERP.BO.BackOfficeContractConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeContractConfig.translate = translateService;
}
super();
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
AccountForCredit:any;
BankAccount:any;
TaxesCashAccount:any;
CashAccount:any;
static setAccountForCredit = ($this, value) => {
var oldValue = $this.AccountForCredit;
$this.AccountForCredit = value;
if (value != null) {
}
}
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}
static setTaxesCashAccount = ($this, value) => {
var oldValue = $this.TaxesCashAccount;
$this.TaxesCashAccount = value;
if (value != null) {
}
}
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}